(() => {
 const init = root => {
  const nav = root.querySelector('.v22-navigation');
  if (!nav || nav.dataset.v22Bound) return;
  nav.dataset.v22Bound = 'true';
  const groups = [...nav.querySelectorAll('[data-v22-nav-details]')];
  const close = except => groups.forEach(group => { if (group !== except) group.open = false; });
  groups.forEach(group => {
   const summary = group.querySelector('summary');
   group.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { close(group); group.open = true; } });
   group.addEventListener('pointerleave', () => { if (!group.contains(document.activeElement)) group.open = false; });
   summary.addEventListener('click', () => close(group));
   summary.addEventListener('keydown', event => { if (event.key === 'ArrowDown') { event.preventDefault(); close(group); group.open = true; group.querySelector('.v22-nav-dropdown a')?.focus(); } });
   group.addEventListener('focusout', event => { if (event.relatedTarget && group.contains(event.relatedTarget)) return; requestAnimationFrame(() => { if (!group.contains(document.activeElement)) group.open = false; }); });
   group.addEventListener('keydown', event => { if (event.key === 'Escape' && group.open) { event.preventDefault(); event.stopPropagation(); group.open = false; summary.focus(); } });
  });
  document.addEventListener('click', event => { if (!nav.contains(event.target)) close(); });

 };
 init(document);
 document.addEventListener('shopify:section:load', event => init(event.target));
})();
